import storage from 'redux-persist/lib/storage';
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import HomeWalletSlice from './slice/home';
import _createMehrSlice from './slice/New/mehr';
import _createStoreSlice from './slice/New/stores';
import connection from './slice/connection';
import debtsReducer from './slice/debts';
import generalSlice from './slice/general';
import loginReducer from './slice/login';
import promissoryNote from './slice/promissoryNote';
import storeSlice from './slice/stores';
import swichComponent from './slice/swich';
import transactionReducer from './slice/transaction';
import walletReducer from './slice/wallet';
import walletRequestOne from './slice/walletRequestStepOne';
import walletRequestTwo from './slice/walletRequestStepTwo';
import { encryptedStorage } from './customStorage';

// import {step} from "./slice/login";
// import persistStore from 'redux-persist/es/persistStore';

const blacklist = [
	'debts',
	'walletRequestOne',
	'walletRequestTwo',
	'HomeWalletSlice',
	'stores',
	'transaction',
	'storeSlice',
	'_createMehrSlice',
	'promissoryNote',
	'wallet',
	'mehr',
	'connection',
	'general',
];

const rootPersistConfig = {
	key: 'A',
	storage: encryptedStorage,
	version: 3,
	blacklist: [...blacklist],
};
const authPersistConfig = {
	key: 'B',
	storage: encryptedStorage,
	version: 3,
	blacklist: ['step', ...blacklist],
};

const rootReducer = combineReducers({
	login: persistReducer(authPersistConfig, loginReducer),
	general: generalSlice,
	transaction: transactionReducer,
	swichComponent,
	wallet: walletReducer,
	walletRequestOne,
	walletRequestTwo,
	storeSlice,
	stores: _createStoreSlice,
	debts: debtsReducer,
	connection,
	promissoryNote,
	HomeWalletSlice,
	mehr: _createMehrSlice,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

const store = configureStore({
	devTools: process.env.NODE_ENV !== 'production',
	reducer: persistedReducer,
});

const persistor = persistStore(store);

export { persistor, store };
